import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CONSTANTS } from '../shared/constants';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AtabexDataService } from './atabex-data.service';
import { PaymentsService } from './payments-service';
import { VacationService } from './vacation.service';
import { environment } from '../../environments/environment';
import { arrayIsDefinedAndContainsKey } from '../shared/array-functions';
import { getCurrentDateForAPI } from '../shared/date-functions';
import { responseIsSuccess } from '../shared/helper-functions';

@Injectable()
export class SubscriptionService {
  private apiUrl: string;
  private gigyaUserId: string;  
  // Customer data
  public customerId: string;   
  public customerSubscriptions: any;
  public printSubscriptions: any;
  public customerPaymentMethods: any;
  public customerBillingAddresses: any;
  public billingAddressToDisplay: any;
  public creditCards: any;
  public otherPaymentMethods: any;
  public packageId: string; 
  public creditPromotionsId: number;
  public creditDescription: string;
  public cutOffDrawDate: string;
  // User input
  public selectedSubscription: any;
  public selectedSubscriptionId: string;  
  public selectedPaymentMethod: object;
  public selectedBillingAddress: object;
  public selectedMethodForOneTimePayment: object;
  // Atabex identifiers
  public atabexIdentifiers: object;
  // View control
  public toggleAddCreditCardForm: boolean;
  public toggleAddBankAccountForm: boolean;
  public toggleAddBillingAddressForm: boolean;
  public inAppSubscriptionTypes: string[];
  public doneLoadingSubscriptionData: boolean;

  constructor(private http: HttpClient, private atabexDataService: AtabexDataService, private paymentsService: PaymentsService, private vacationService: VacationService) {
    this.apiUrl =  environment.api.protocol + environment.api.hostname + environment.api.path;
    this.doneLoadingSubscriptionData = false;
    this.atabexIdentifiers = {};
  }

 /*
    * Get subscriptions of a customer, payment types and collection types
    * API endpoint: SubscriptionInfo?GigyaUserID=gigyaUserId
    * API endpoint: GetPaymentTypes
    * API endpoint: Get_CollectionType_Desc
  */
  getSubscriptionDataSynch(gigyaUserId){
    this.gigyaUserId = gigyaUserId;
    const route1 = 'SubscriptionInfo';
    const route2 = 'GetPaymentTypes';
    const route3 = 'Get_CollectionType_Desc';
    Observable.forkJoin(
        this.http.get(this.apiUrl + route1 + '?' + CONSTANTS.api.gigyaIdQueryParam + '=' + gigyaUserId).map((res:Response) => {
          return res;  
       }),
        this.http.get(this.apiUrl + route2).map((res:Response) => {
          return res;  
        }),
        this.http.get(this.apiUrl + route3).map((res:Response) => { 
          return res; 
        })
    ).subscribe(
      data => {
        if (arrayIsDefinedAndContainsKey(data[0], 'CMS_SAM_SubscriptionInfo_ByGigyaID')) {
          this.customerSubscriptions = data[0]['CMS_SAM_SubscriptionInfo_ByGigyaID'];
          this.printSubscriptions = data[0]['CMS_SAM_SubscriptionInfo_ByGigyaID'].filter((subscription) => { return subscription.NoPrintSubscription === 0 }); // If false, it means that it has print subscription
          this.customerId = this.customerSubscriptions[0].CustID; 
        } 
        if (arrayIsDefinedAndContainsKey(data[1], 'CMS_PaymentTypeSelect')) {     
          this.atabexIdentifiers['creditCardId'] = data[1]['CMS_PaymentTypeSelect'].find((type) => { return type.PaymentTypeName === 'CC'}).PaymentTypeID;
          this.atabexIdentifiers['bankAccountId'] = data[1]['CMS_PaymentTypeSelect'].find((type) => { return type.PaymentTypeName === 'DD'}).PaymentTypeID;
          this.atabexIdentifiers['checkId'] = data[1]['CMS_PaymentTypeSelect'].find((type) => { return type.PaymentTypeName === 'CHECK'}).PaymentTypeID;
          this.atabexIdentifiers['cashId'] = data[1]['CMS_PaymentTypeSelect'].find((type) => { return type.PaymentTypeName === 'CASH'}).PaymentTypeID;
          data[0] ? this.getDataforSelectedSubscription(data[0]['CMS_SAM_SubscriptionInfo_ByGigyaID'][0]) : '';
        }
        if (arrayIsDefinedAndContainsKey(data[2], 'Get_CollectionType')) {
          this.atabexIdentifiers['carrierCollectId'] = data[2]['Get_CollectionType'].find((collectionType) => { return collectionType['CollectionTypeDesc'] === 'Carrier Collect'})['CollectionTypeID'];
          this.atabexIdentifiers['easyPayId'] = data[2]['Get_CollectionType'].find((collectionType) => { return collectionType['CollectionTypeDesc'] === 'Easy Pay'})['CollectionTypeID'];
          this.atabexIdentifiers['prepaidId'] = data[2]['Get_CollectionType'].find((collectionType) => { return collectionType['CollectionTypeDesc'] === 'Prepaid'})['CollectionTypeID'];      
        }
        this.doneLoadingSubscriptionData = true;
      },
      err => this.handleError(err)
    );
  }

  getDataforSelectedSubscription(subscription) {
    this.selectedSubscription = subscription;
    this.selectedSubscriptionId = subscription.SubID;
    this.packageId = subscription.PackageID;
    this.creditPromotionsId = subscription.CreditPromotionsId;
    this.cutOffDrawDate = subscription.CutOffDrawDate;
    this.getPaymentMethods();
    this.getBillingAddresses();
    this.atabexDataService.getStates(); 
    this.vacationService.getVacationList(subscription.SubID);
  }

  /*
    * Get All Customer Payment Methods
    * API endpoint: AllCustomerPaymentMethods?CustID=customerId&SubID=subID
  */
  getPaymentMethods() {
    const subscriptionId = this.selectedSubscription['SubID'];
    const route = 'AllCustomerPaymentMethods';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.customerIdQueryParam + '=' + this.customerId + '&' + CONSTANTS.api.subscriptionIdQueryParam + '=' + subscriptionId).subscribe(
      (data) => {
        if (data && data['CMS_SAM_PaymentMethodByCustomer']) {
          this.customerPaymentMethods = data['CMS_SAM_PaymentMethodByCustomer'];
          this.creditCards = this.customerPaymentMethods.filter((paymentMethod) => { return paymentMethod.PaymentTypeID === this.atabexIdentifiers['creditCardId'] });
          this.otherPaymentMethods = this.customerPaymentMethods.filter((paymentMethod) => { return paymentMethod.PaymentTypeID !== this.atabexIdentifiers['creditCardId'] });
          const subscriptionPaymentMethod = this.customerPaymentMethods.find((paymentMethod) => { return paymentMethod.PaymentMethodSelected === true });
          subscriptionPaymentMethod ? this.selectedPaymentMethod = subscriptionPaymentMethod : this.selectedPaymentMethod = undefined;
          subscriptionPaymentMethod ? this.selectedMethodForOneTimePayment = subscriptionPaymentMethod : this.selectedMethodForOneTimePayment = this.customerPaymentMethods[0];
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    });
  } 

  /*
    * Delete Payment Method
    * API endpoint: PaymentMethod?PaymentMethodID=paymentMethodID 
  */
  deletePaymentMethod(paymentMethodId): Observable<any> {
    const route = 'PaymentMethod';
    return this.http.delete(this.apiUrl + route + '?' + CONSTANTS.api.paymentMethodIdQueryParam + '=' + paymentMethodId + '&' + CONSTANTS.api.subscriptionIdQueryParam + '=' + this.selectedSubscriptionId)
    .map((res: Response) => { 
      this.getPaymentMethods();
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Change payment method of a subscription
    * API endpoint: /PaymentMethod
    * Request Payload: SubID, PaymentMethodID, EffectiveDate
  */
  changePaymentMethod(subscriptionID, paymentMethodId): Observable<any> {
    const route = 'PaymentMethod';
    const payload = {
      SubID: subscriptionID,
      PaymentMethodID: paymentMethodId,
      EffectiveDate: getCurrentDateForAPI()
    };  
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {       
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /* 
    * Create a new a payment method
    * API endpoint: /PaymentMethod
    * Request Payload: PaymentMethodID, CustID, PaymentTypeID, AccountNumber, CreditCardType, CCExpirationMonth, CCExpirationYear, CreditCardName, CreditCardCVC, AbaRouting, Visible, CollectionTypeID, CustAddrID   
  */
  createOrUpdatePaymentMethod(payload): Observable<any> {
    const route = 'PaymentMethod';
    return this.http.patch(this.apiUrl + route, payload)
    .map((res: Response) => {
      this.getPaymentMethods();
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Create a new payment method (when changing from carrier collect to easy pay)
    * API endpoint: /PaymentMethodonChangeCarrierCollect
    * Request Payload: SubID, PaymentMethodID, CustID, PaymentTypeID, AccountNumber, CreditCardType, CCExpirationMonth, CCExpirationYear, CreditCardName, CreditCardCVC, AbaRouting, Visible, CollectionTypeID, CustAddrID   
  */
  createEasyPayPaymentMethod(payload): Observable<any> {
    const route = 'PaymentMethodonChangeCarrierCollect';
    return this.http.patch(this.apiUrl + route, payload)
    .map((res: Response) => {
      return res;
    }).catch((error: any) =>
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Get All Customer Billing Addresses
    * API endpoint: AllCustomerBillingAddress?CustID=customerId&PaymentMethodID=paymentMethodId
  */
  getBillingAddresses() {
    let paymentMethodId;
    this.selectedSubscription['PaymentMethodID'] ? paymentMethodId = this.selectedSubscription['PaymentMethodID'] : paymentMethodId = 0;
    const customerId = this.customerId;
    const route = 'AllCustomerBillingAddress';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.customerIdQueryParam + '=' + customerId + '&' + CONSTANTS.api.paymentMethodIdQueryParam + '=' + paymentMethodId).subscribe(
      (data) => {
        if (arrayIsDefinedAndContainsKey(data, 'CMS_SAM_Get_CustomerBillingAddresses_ByCustomerId')) {
          this.customerBillingAddresses = data['CMS_SAM_Get_CustomerBillingAddresses_ByCustomerId'];
          const subscriptionBillingAddress = data['CMS_SAM_Get_CustomerBillingAddresses_ByCustomerId'].find((address) => { return address.AddressSelected === true });
          subscriptionBillingAddress ? this.billingAddressToDisplay = subscriptionBillingAddress : this.billingAddressToDisplay = undefined;
          subscriptionBillingAddress ? this.selectedBillingAddress = subscriptionBillingAddress : this.selectedBillingAddress = undefined;
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    });
  }

  /*
   * Change billing address of a payment method
   * API endpoint: PaymentMethodAddress
  */
  changeBillingAddress(paymentMethodId, customerAddressId): Observable<any> {
    const route = 'PaymentMethodAddress';
    const payload = {  
      PaymentMethodID: paymentMethodId,
      CustID: this.customerId,
      CustAddrID: customerAddressId
    };
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {
      return res; 
    }).catch((error:any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /* 
    * Create a new billing address
    * API endpoint: /AddCustomerAddresses
    * Request Payload: CustID, AddrTypeID, AddrStatusID, AddressLine1, AddressLine2, City, StateID, Country, ZipCode, ZipCodeExt
  */
  createBillingAddress(payload): Observable<any> {
    const route = 'AddCustomerAddresses';
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {
      this.getBillingAddresses();
      return res; 
    }).catch((error:any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Delete Billing Address
    * API endpoint: /DeleteCustomerAddress?CustID=825997&CustAddrID=64462
  */
  deleteBillingAddress(customerAddressId): Observable<any> {
    const route = 'DeleteCustomerAddress';
    return this.http.delete(this.apiUrl + route + '?' + CONSTANTS.api.customerIdQueryParam + '=' + this.customerId + '&' + CONSTANTS.api.customerAddressIdQueryParam + '=' + customerAddressId)
    .map((res: Response) => { 
      this.getBillingAddresses();
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
    * Get Customer Billing Address by Payment Method
    * API endpoint: CustomerBillingAddress?PaymentMethodID=paymentMethodId
  */
  getBillingAddressByPaymentMethodId(paymentMethodId) {
    const route = 'CustomerBillingAddress';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.paymentMethodIdQueryParam + '=' + paymentMethodId)
    .map((res: Response) => { 
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
   * Look up for a customer's subscription
   * API endpoint: FindSubscription
   * Request payload: FirstName, LastName, Email, Phone, DeliveryZipCode
  */
  findSubscription(payload): Observable<any> {
    const route = 'FindSubscription';
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
   * Activate a customer's subscription
   * Upgrade print subscription (add digital access)
   * API endpoint: ActivateSubscription
   * Request payload: GigyaID, CustID, Email
  */
  activateSubscription(payload): Observable<any> {
    const route = 'ActivateSubscription';
    return this.http.patch(this.apiUrl + route, payload)
    .map((res: Response) => {
      return res; 
    }).catch((error: any) => 
      Observable.throw(error || 'Server error')
    );
  }

  /*
   * Get type of customer's subscriptions (iOS, Android, Atabex)
   * API endpoint: PianoUserDevice?GigyaUserID=gigyaUserId
  */
  getPianoInfo(gigyaUserId, email): Observable<any> {
    const route = 'PianoUserDevice';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.gigyaIdQueryParam + '=' + gigyaUserId + '&' + CONSTANTS.api.emailQueryParam + '=' + email)    
    .map((res: Response) => {
      return res;
    }).catch((error: any) =>
      Observable.throw(error || 'Server error')
    );
  }

  showInAppSubscriptionMessage(subscriptionTypes) {
    this.inAppSubscriptionTypes = subscriptionTypes;
  }

  getUpdatedSelectedSubscription() {
    const route = 'SubscriptionInfo';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.gigyaIdQueryParam + '=' + this.gigyaUserId).subscribe(
      (data) => {
        if (arrayIsDefinedAndContainsKey(data, 'CMS_SAM_SubscriptionInfo_ByGigyaID')) {
          this.customerSubscriptions = data['CMS_SAM_SubscriptionInfo_ByGigyaID'];
          this.printSubscriptions = data['CMS_SAM_SubscriptionInfo_ByGigyaID'].filter((subscription) => { return subscription.NoPrintSubscription === 0 }); // If false, it means that it has print subscription
          data['CMS_SAM_SubscriptionInfo_ByGigyaID'].forEach((subscription) => {
            this.atabexDataService.validateEncryptedValues(subscription.SubID, this.selectedSubscriptionId).subscribe((response) => {
              if (response === 1) {
                this.selectedSubscription = subscription;
                this.getDataforSelectedSubscription(subscription);
              }
            });
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    });
  }

  /*
   * Get credit promotion description if there is an active promotion for switch to easy pay
   * API endpoint: CreditPromotion
  */
  getCreditPromotion() {
    const route = 'CreditPromotion';
    return this.http.get(this.apiUrl + route).subscribe(
      (response) => {
        if (responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'SAM_CreditPromotion') && response['SAM_CreditPromotion'][0]['Active']) {
          this.creditDescription = response['SAM_CreditPromotion'][0]['CreditDescription'];
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    });
  } 
  
  private handleError(err:HttpErrorResponse){
    if (err.error instanceof Error) {
      // A client-side or network error occurred
      console.error('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code
      console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
    }
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/subscription.service.ts